import { useCallback, useState } from 'react';

/** Tracks which file's download is waiting on its signed URL, so its control can show a pending state. */
export function usePendingDownload() {
  const [pendingId, setPendingId] = useState<string>();

  const track = useCallback(async (fileId: string | undefined, download: () => Promise<void>) => {
    setPendingId(fileId);
    try {
      await download();
    } finally {
      setPendingId((current) => (current === fileId ? undefined : current));
    }
  }, []);

  return { pendingId, track };
}
